(function () {
  if (window.__mtInit) return;
  window.__mtInit = true;

  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observador = 'IntersectionObserver' in window ? new IntersectionObserver(function (entradas) {
    entradas.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('mt-visible'); observador.unobserve(e.target); }
    });
  }, { threshold: 0, rootMargin: '0px 0px 12% 0px' }) : null;

  function initReveals(raiz) {
    raiz.querySelectorAll('.mt-reveal, .mt-pasos-grid, .mt-comp-tabla').forEach(function (el) {
      if (el.dataset.mtObs) return;
      el.dataset.mtObs = '1';
      if (!observador || reducido) { el.classList.add('mt-visible'); return; }
      observador.observe(el);
    });
  }

  function initEscenarios(raiz) {
    raiz.querySelectorAll('[data-mt-escenarios]').forEach(function (bloque) {
      if (bloque.dataset.mtInit) return;
      bloque.dataset.mtInit = '1';
      var tabs = bloque.querySelectorAll('.mt-esc-tab');
      var escenas = bloque.querySelectorAll('.mt-esc-escena');
      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t, j) { t.setAttribute('aria-selected', j === i ? 'true' : 'false'); });
          escenas.forEach(function (s, j) { s.classList.toggle('mt-activa', j === i); });
        });
      });
    });
  }

  function initCaja(raiz) {
    raiz.querySelectorAll('.mt-caja-punto button').forEach(function (b) {
      if (b.dataset.mtInit) return;
      b.dataset.mtInit = '1';
      b.addEventListener('click', function () {
        var p = b.parentElement;
        var activo = p.classList.contains('mt-activo');
        p.parentElement.querySelectorAll('.mt-caja-punto').forEach(function (x) { x.classList.remove('mt-activo'); });
        if (!activo) p.classList.add('mt-activo');
      });
    });
  }

  function initMagnetico(raiz) {
    if (reducido || !window.matchMedia('(hover: hover)').matches) return;
    raiz.querySelectorAll('.mt-magnetico').forEach(function (btn) {
      if (btn.dataset.mtInit) return;
      btn.dataset.mtInit = '1';
      var zona = btn.parentElement;
      zona.addEventListener('mousemove', function (ev) {
        var r = btn.getBoundingClientRect();
        var dx = ev.clientX - (r.left + r.width / 2);
        var dy = ev.clientY - (r.top + r.height / 2);
        var dist = Math.sqrt(dx * dx + dy * dy);
        if (dist > 160) { btn.style.transform = ''; return; }
        btn.style.transform = 'translate(' + (dx * 0.06).toFixed(1) + 'px,' + (dy * 0.1).toFixed(1) + 'px)';
      });
      zona.addEventListener('mouseleave', function () { btn.style.transform = ''; });
    });
  }

  function initGaleria(raiz) {
    raiz.querySelectorAll('[data-mt-galeria]').forEach(function (g) {
      if (g.dataset.mtInit) return;
      g.dataset.mtInit = '1';
      var principal = g.querySelector('.mt-galeria-principal img');
      g.querySelectorAll('.mt-galeria-minis button').forEach(function (b) {
        b.addEventListener('click', function () {
          if (b.dataset.srcset) principal.srcset = b.dataset.srcset;
          principal.src = b.dataset.src;
          principal.alt = b.dataset.alt || '';
          g.querySelectorAll('.mt-galeria-minis button').forEach(function (x) { x.setAttribute('aria-current', x === b ? 'true' : 'false'); });
        });
      });
    });
  }

  function initVariantes(raiz) {
    raiz.querySelectorAll('[data-mt-compra]').forEach(function (c) {
      if (c.dataset.mtInit) return;
      c.dataset.mtInit = '1';
      var datos = c.querySelector('[data-mt-variantes]');
      if (!datos) return;
      var variantes = JSON.parse(datos.textContent);
      var selects = c.querySelectorAll('.mt-variantes select');
      var input = c.querySelector('input[name="id"]');
      var boton = c.querySelector('button[name="add"]');
      var precio = c.querySelector('[data-mt-precio]');
      var tachado = c.querySelector('[data-mt-tachado]');
      var formato = c.dataset.mtFormato || '';
      function dinero(cent) {
        var v = (cent / 100).toFixed(2);
        return formato.indexOf('{{') > -1 ? formato.replace(/\{\{\s*\w+\s*\}\}/, v.replace('.', formato.indexOf('comma') > -1 ? ',' : '.')) : v;
      }
      function actualizar() {
        var elegidas = Array.prototype.map.call(selects, function (s) { return s.value; });
        var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === elegidas[i]; }); });
        if (!v) return;
        input.value = v.id;
        if (precio) precio.textContent = dinero(v.price);
        if (tachado) { tachado.textContent = v.compare_at_price > v.price ? dinero(v.compare_at_price) : ''; }
        boton.disabled = !v.available;
        boton.querySelector('span').textContent = v.available ? boton.dataset.textoOk : boton.dataset.textoAgotado;
      }
      selects.forEach(function (s) { s.addEventListener('change', actualizar); });
    });
  }

  function initBarra(raiz) {
    raiz.querySelectorAll('[data-mt-barra]').forEach(function (barra) {
      if (barra.dataset.mtInit) return;
      barra.dataset.mtInit = '1';
      var seccion = barra.closest('.shopify-section') || document;
      var principal = seccion.querySelector('.mt-compra form button[name="add"]');
      if (!principal || !('IntersectionObserver' in window)) { barra.remove(); return; }
      new IntersectionObserver(function (entradas) {
        var ver = !entradas[0].isIntersecting;
        barra.classList.toggle('mt-barra-visible', ver);
        barra.setAttribute('aria-hidden', ver ? 'false' : 'true');
      }).observe(principal);
      barra.querySelector('[data-mt-barra-btn]').addEventListener('click', function () { principal.click(); });
    });
  }

  function initTodo(ev) {
    var raiz = (ev && ev.target && ev.target.querySelectorAll) ? ev.target : document;
    initReveals(raiz); initEscenarios(raiz); initCaja(raiz); initMagnetico(raiz); initGaleria(raiz); initVariantes(raiz); initBarra(raiz);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTodo); else initTodo();
  document.addEventListener('shopify:section:load', initTodo);
})();
